import LocaleService from '../services/locale.service';

export class DistanceHelper {
  public static format(value: number | undefined | null): string {
    if (value === null || value === undefined || value < 0) {
      return '';
    }

    const locale = window.navigator.language || LocaleService.getLocale();
    if (value < 1000) {
      return `${value.toLocaleString(locale)} m`;
    }
    return `${(value / 1000).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 1 })} km`;
  }

  public static calculateDistanceInMeters(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371000; // Earth's radius in meters
    const toRadians = (degrees: number) => degrees * (Math.PI / 180);

    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in meters
  }
}
